/// <reference path="../../_references.ts" />
module onvio.setup.list {
    'use strict';

    bmp.RegisterMasterDetailView(new bmp.MasterDetailDefinition('Employee Rate Description')
        ///*i18nextract*/'Onvio.Setup.EmployeeRateDescription.Detail.Add'
        ///*i18nextract*/'Bluemoon.Setup.EmployeeRateDescription.List.DeleteConfirmationMessage'
        ///*i18nextract*/'Onvio.Setup.StaffRate.Modal.Title'
        .withUrl('/setup/staff-rate-descriptions')  /* inconsistencies in naming convention */
        .withFeature('StaffRateDescriptions')       /* inconsistencies in naming convention */
        .withMasterViewWorkspaceMode('Onvio.Setup.StaffRate.Modal.Title')
        .withField(new bmp.MasterDetailFieldDefinition('Name').asPrimary().asTitle().withMaxLength(200)));

    bmp.RegisterMasterDetailView(new bmp.MasterDetailDefinition('Activity Category')
        ///*i18nextract*/'Onvio.Setup.ActivityCategory.Detail.Add'
        ///*i18nextract*/'Bluemoon.Setup.ActivityCategory.List.DeleteConfirmationMessage'
        .withField(new bmp.MasterDetailFieldDefinition('Code').asPrimary().withMaxLength(20))
        .withField(new bmp.MasterDetailFieldDefinition('Name').asTitle().withMaxLength(200))
        .withField(new bmp.MasterDetailFieldDefinition('Invoice Description').withMaxLength(200).asMultiline().keepInSyncWith('Name'))
        .withMasterViewWorkspaceMode('Onvio.SetupAssistant.Modal.ActivityCategories.Title')
        .withGroupPanel(false)
        .withGroupButton(false));

    bmp.RegisterMasterDetailView(new bmp.MasterDetailDefinition('Engagement Category')
        ///*i18nextract*/'Onvio.Setup.EngagementCategory.Detail.Add'
        ///*i18nextract*/'Bluemoon.Setup.EngagementCategory.List.DeleteConfirmationMessage'
        ///*i18nextract*/'Onvio.SetupAssistant.Modal.EngagementCategories.Title'
        .withMasterViewWorkspaceMode('Onvio.SetupAssistant.Modal.EngagementCategories.Title')
        .withField(new bmp.MasterDetailFieldDefinition('Code').asPrimary().withMaxLength(20))
        .withField(new bmp.MasterDetailFieldDefinition('Name').asTitle().withMaxLength(200))
        .withField(new bmp.MasterDetailFieldDefinition('Invoice Description').withMaxLength(200).asMultiline().keepInSyncWith('Name'))
        .withGroupPanel(false)
        .withGroupButton(false));

    bmp.RegisterMasterDetailView(new bmp.MasterDetailDefinition('Bank Account')
        ///*i18nextract*/'Onvio.Setup.BankAccount.Detail.Add'
        ///*i18nextract*/'Bluemoon.Setup.BankAccount.List.DeleteConfirmationMessage'
        ///*i18nextract*/'Onvio.Setup.BankAccount.Detail.SystemIdMessage'
        ///*i18nextract*/'Onvio.Setup.BankAccounts.Modal.Title'
        .withMasterViewWorkspaceMode('Onvio.Setup.BankAccounts.Modal.Title')
        .withField(new bmp.MasterDetailFieldDefinition('Code').asPrimary().withMaxLength(20))
        .withField(new bmp.MasterDetailFieldDefinition('Name').asTitle().withMaxLength(200))
        .withPrimaryKey('bankAccountId')
        .withGroupPanel(false)
        .withGroupButton(false));

    bmp.RegisterMasterDetailView(new bmp.MasterDetailDefinition('Engagement Template')
        ///*i18nextract*/'Onvio.Setup.EngagementTemplate.Detail.Add'
        ///*i18nextract*/'Bluemoon.Setup.EngagementTemplate.List.DeleteConfirmationMessage'
        ///*i18nextract*/'Onvio.Setup.EngagementTemplate.Modal.Title'
        .withMasterViewWorkspaceMode('Onvio.Setup.EngagementTemplate.Modal.Title')
        .withField(new bmp.MasterDetailFieldDefinition('Code').asPrimary().withMaxLength(20)
            .asGridColumn('Core.Captions.EngagementTemplateView.Code'))
        .withField(new bmp.MasterDetailFieldDefinition('Name').asTitle().withMaxLength(200)
            .asGridColumn('Core.Captions.EngagementTemplateView.Name'))
        .withField(new bmp.MasterDetailFieldDefinition('Invoice Description')
            .keepInSyncWith('name')
            .withMaxLength(200)
            .asMultiline()
            .asGridColumn('Core.Captions.EngagementTemplateView.InvoiceDescription'))
        .withField(new bmp.MasterDetailFieldDefinition('officeName')
            .asGridColumn('Core.Captions.EngagementTemplateView.OfficeName'))
        .withField(new bmp.MasterDetailFieldDefinition('category').withChildProperty('name')
            .asGridColumn('Core.Captions.EngagementTemplateView.Category'))
        .withField(new bmp.MasterDetailFieldDefinition('billerName')
            .asGridColumn('Core.Captions.EngagementTemplateView.BillerName'))
        .withField(new bmp.MasterDetailFieldDefinition('reviewerName')
            .asGridColumn('Core.Captions.EngagementTemplateView.ReviewerName'))
        .withField(new bmp.MasterDetailFieldDefinition('managerName')
            .asGridColumn('Core.Captions.EngagementTemplateView.ManagerName'))
        .withExpansions('code,name,invoiceDescription,officeName,category.name,billerName,reviewerName,managerName')
        .withService('onvio.setup.list.EngagementTemplateServiceProxy')
        .withCustomDetailScreen(true));

    bmp.RegisterMasterDetailView(new bmp.MasterDetailDefinition('Late Fee Template')
        ///*i18nextract*/'Onvio.Setup.LateFeeTemplate.Detail.Add'
        ///*i18nextract*/'Bluemoon.Setup.LateFeeTemplate.List.DeleteConfirmationMessage'
        .withField(new bmp.MasterDetailFieldDefinition('Name').asPrimary().asTitle().withMaxLength(200)
            .asGridColumn('Core.Captions.NamedReference.Name'))
        .withUrl('/setup/late-fees')
        .withService('onvio.setup.list.LateFeeTemplateServiceProxy')
        .withCustomDetailScreen(true)
        .withGroupPanel(false)
        .withGroupButton(false)
        .withColumnPicker(false));

    bmp.RegisterMasterDetailView(new bmp.MasterDetailDefinition('Standard Text')
        ///*i18nextract*/'Onvio.Setup.StandardText.Detail.Add'
        ///*i18nextract*/'Bluemoon.Setup.StandardText.List.DeleteConfirmationMessage'
        ///*i18nextract*/'Onvio.Setup.StandardText.Modal.Title'
        .withMasterViewWorkspaceMode('Onvio.Setup.StandardText.Modal.Title')
        .withFeaturePrefix('TimeAndBilling')
        .withFeature('StandardText')
        .withUrl('/setup/standard-text')
        .withField(new bmp.MasterDetailFieldDefinition('Code').asPrimary().asTitle().withMaxLength(20))
        .withField(new bmp.MasterDetailFieldDefinition('Text').isRequired()
            .asGridColumn('Core.Captions.StandardText.Text'))
        .withGroupPanel(false)
        .withGroupButton(false));

}
